<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="Prelims-head">Dedication</p>
<p class="Prelim-main _idGenParaOverride-1">To my siblings, Kate and Jonathan, and the school runs we did together</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781035821600_EPUB2.vue?1c440724